<template>
  <div class="report-module module" :id="moduleData.itemCode" style="padding-bottom: 20px;">
    <div class="module-label">{{moduleData.itemName}}</div>
    <el-form :class="{ 'cs-form': isCs }" :model="form" :rules="rules" ref="form" label-width="165px" label-position="right" v-if="formConfig.length">
      <el-row>
        <el-col :span="24">
          <el-form-item prop="labId" :label="configByCode.labId.attrName" class="is-required" v-if="configByCode.labId">
            <el-radio-group v-model="form.labId" :disabled="disabledAll || ((formDisabled('lab') || (!isCreate && form.state > 11)) && !configByCode.labId.showAttr.canEdit)">
              <el-radio v-for="item in labList" :key="item.labId" :label="item.labId">{{item.labName}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="isUrgent" :label="configByCode.cycleRequirements.attrName" class="is-required" v-if="configByCode.cycleRequirements">
            <el-input disabled v-model="form.isUrgentShow" v-if="isOiq"></el-input>
            <template v-else>
              <el-select v-model="form.isUrgent" placeholder="请选择" :disabled="disabledAll">
                <el-option v-for="item in configByCode.cycleRequirements.enums" :key="item.enumCode" :label="item.enumName"
                           :value="Number(item.enumCode)">
                </el-option>
              </el-select>
              <div v-if="form.isUrgent !== 1" style="word-break: keep-all;line-height: 16px;font-size: 12px;color: #878787;margin-top: 10px;">加急服务周期以业务顾问最终确认为准</div>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="labId" :label="configByCode.sampleReceivingLocation.attrName" class="is-required" v-if="configByCode.sampleReceivingLocation">
            <el-select v-model="form.labId" placeholder="请选择" :disabled="disabledAll || ((formDisabled('lab') || (!isCreate && form.state > 11)) && !configByCode.sampleReceivingLocation.showAttr.canEdit)">
              <el-option v-for="item in labList" :key="item.labId" :label="item.labName" :value="item.labId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24"></el-col>
        <el-col :span="8">
          <el-form-item prop="salesEmail" :label="configByCode.salesEmail.attrName" class="is-required lab-item" v-if="configByCode.salesEmail">
            <el-input :placeholder="configByCode.salesEmail.fillNotice" v-model="form.salesEmail" :maxlength="configByCode.salesEmail.fillLen"
                      :disabled="disabledAll || form.salesEmailFlg === 1 || (((!isCreate && form.state > 11) || formDisabled('sales')) && !configByCode.salesEmail.showAttr.canEdit)">
              <template #suffix>
                <img src="../../../assets/images/apply/lock.png" alt="" style="margin-right: 10px;" v-if="formDisabled('sales') && !configByCode.salesEmail.showAttr.canEdit">
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16" style="padding-top: 12px;" v-if="!isOiq">
          <el-checkbox @change="e => flgChange(e, 'salesEmail')" v-model="form.salesEmailFlg" :disabled="disabledAll || (((!isCreate && form.state > 11) || formDisabled('sales')) && !configByCode.salesEmail.showAttr.canEdit)" class="copy-checkbox" :true-label="1" :false-label="0">暂不清楚，待SGS分配</el-checkbox>
        </el-col>
        <el-col :span="24"></el-col>
        <el-col :span="8">
          <el-form-item :prop="isOiq ? '' : 'businessPersonEmail'" :label="configByCode.businessPersonEmail.attrName" class="is-required lab-item" v-if="configByCode.businessPersonEmail">
            <el-input :placeholder="configByCode.businessPersonEmail.fillNotice" v-model="form.businessPersonEmail" :maxlength="configByCode.businessPersonEmail.fillLen"
                      :disabled="disabledAll || form.defaultEmailFlg === 1 || ((isCs || isOiq || (!isCreate && form.state > 11) || formDisabled('crm')) && !configByCode.businessPersonEmail.showAttr.canEdit)">
              <template #suffix>
                <img src="../../../assets/images/apply/lock.png" alt="" style="margin-right: 10px;" v-if="formDisabled('crm') && !configByCode.businessPersonEmail.showAttr.canEdit">
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16" style="padding-top: 12px;" v-if="!isOiq">
          <el-checkbox @change="e => flgChange(e, 'businessPersonEmail')" v-model="form.defaultEmailFlg" :disabled="disabledAll || (((!isCreate && form.state > 11) || formDisabled('crm')) && !configByCode.businessPersonEmail.showAttr.canEdit)" class="copy-checkbox" :true-label="1" :false-label="0">暂不清楚，待SGS分配</el-checkbox>
        </el-col>
        <el-col :span="24" class="reportEmail" v-if="configByCode.customerList">
          <el-form-item :label="configByCode.customerList.attrName" :class="{'is-error': showAddBuyerErr}">
            <span v-for="(item, index) in form.customerList" :key="index" class="email-item">
              {{ item.customer }}
              <el-button type="text" @click="delBuyer(index)" class="del-email" v-if="!disabledAll">删除</el-button>
            </span>
            <div class="add-email-input" v-show="isAddBuyer">
              <div>
                <el-input v-model="currentBuyer" @keyup.enter.native="saveBuyer" ref="buyerInput" maxlength="200" placeholder="请输入买家名称或用户账号"></el-input>
                <el-button type="primary" class="add-email" @click="saveBuyer" :loading="addBuyerLoading">保存</el-button>
                <el-button class="cancel-add" @click="isAddBuyer = false" :loading="addBuyerLoading">取消</el-button>
              </div>
              <div class="err-msg" v-if="showAddBuyerErr">{{ buyerErrMsg }}</div>
            </div>
            <el-button class="common-btn" :disabled="disabledAll" @click="addBuyer" v-if="!isAddBuyer">+添加分享对象</el-button>
          </el-form-item>
          <div class="buyer-tips">添加后，订单进度和报告将共享给对方</div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import {applyMixins} from "src/components/application/components/mixin";
import { qryLab } from "src/request/apis";
import {getParam} from "utils";
export default {
  name: "ServiceInfo",
  mixins: [applyMixins],
  data() {
    return {
      form: {
        isUrgent: '',
        isUrgentShow: '',
        labId: '',
        businessPersonEmail: '',
        defaultEmailFlg: 0,
        salesEmailFlg: 0,
        tails: []
      },
      labList: [],
      testCycleList: [],
      hasLab: false,
      hasCs: false,
      hasSale: false,
      isAddBuyer: false,
      currentBuyer: '',
      buyerErrMsg: '',
      showAddBuyerErr: false,
      addBuyerLoading: false,
      configByCode: {},
    }
  },
  computed: {
    rules() {
      const validateCsEmail = (rule, value, callback) => {
        if (this.form.defaultEmailFlg !== 1 && !value) {
          return callback(new Error('必填项'))
        } else if (value && !this.csMailReg.test(value)) {
          return callback(new Error('请输入完整的SGS服务顾问邮箱'))
        } else {
          return callback()
        }
      }
      const validateSaleEmail = (rule, value, callback) => {
        if (this.isSave && this.form.salesEmailFlg !== 1 && !value) {
          return callback(new Error('必填项'))
        } else if (value && !this.csMailReg.test(value)) {
          return callback(new Error('请输入完整的SGS销售经理邮箱'))
        } else {
          return callback()
        }
      }
      return {
        isUrgent: [this.required],
        labId: [this.required],
        businessPersonEmail: [
          { validator: validateCsEmail }
        ],
        salesEmail: [
          { validator: validateSaleEmail }
        ],
      }
    }
  },
  watch: {
    formConfig: {
      handler(val) {
        if (!val.length) return
        const configObj = val.find(v => v.areaCode === 'ServiceInfo') || {}
        const configArr = configObj.attrs || []
        this.configByCode = this.getFormConfigByCode(configArr)
      },
      immediate: true
    },
    enumConfig: {
      handler(val) {
        if (val) {
          const buInfo = this.buName ? this.buName.toUpperCase() + '_' : ''
          const testCycleList = JSON.parse(JSON.stringify(val[`ORDER_BASE_INFO.${buInfo}TEST_CYCLE`]))
          this.testCycleList = testCycleList.map(v => {
            v.enumCode = Number(v.enumCode)
            if (v.remark !== '0') v.enumName = `${v.enumName}（费用+${v.remark}%）`
            return v
          })
        }
      },
      immediate: true
    },
    formInfo: {
      handler(val) {
        if (val) {
          if (this.moduleData.sourceFormatJson) {
            this.form = this.formatByJson(val, this.moduleData.sourceFormatJson)
          } else {
            this.form = JSON.parse(JSON.stringify(val))
          }
          this.form.tails = !this.isCreate && this.form.tails ? this.form.tails.split(',') : []
          const crm = getParam(this.$route.query, 'crm')
          const sales = getParam(this.$route.query, 'sales')
          this.hasCs = this.csMailReg.test(crm)
          this.hasSale = this.csMailReg.test(sales)
          if (this.hasCs) {
            this.form.businessPersonEmail = crm
            if (this.isCreate) {
              this.form.tails.push('crm')
            }
          }
          if (this.hasSale) {
            this.form.salesEmail = sales
            if (this.isCreate) {
              this.form.tails.push('sales')
            }
          }
          if (this.isCs && this.isCreate) {
            this.form.businessPersonEmail = this.csInfo.personMail
          }
        }
      },
      immediate: true
    },
  },
  created() {
    this.qryLab()
  },
  methods: {
    delBuyer(index) {
      this.form.customerList.splice(index, 1)
    },
    saveBuyer() {
      return new Promise(resolve => {
        if (!this.currentBuyer) {
          this.showAddBuyerErr = true
          this.buyerErrMsg = '请输入'
          resolve(false)
          return
        }
        if (this.form.customerList.some(v => v.customer === this.currentBuyer)) {
          this.showAddBuyerErr = true
          this.buyerErrMsg = '您已添加此买家'
          resolve(false)
          return
        }
        this.addBuyerLoading = true
        this.apis.getCustomerIdList({
          customers: [this.currentBuyer]
        }).then(res => {
          if (res && res.resultCode !== '0') {
            this.showAddBuyerErr = true
            this.buyerErrMsg = res.resultMsg
            resolve(false)
            return
          }
          this.addBuyerLoading = false
          this.form.customerList = this.form.customerList.concat(res.data.items)
          this.isAddBuyer = false
          this.showAddBuyerErr = false
          resolve(true)
        }).catch(e => {
          resolve(false)
          if (e && e.resultMsg) {
            this.showAddBuyerErr = true
            this.buyerErrMsg = e.resultMsg
          }
          this.addBuyerLoading = false
        })
      })
    },
    addBuyer() {
      this.currentBuyer = ''
      this.buyerErrMsg = ''
      this.isAddBuyer = true
      this.showAddBuyerErr = false
      this.$nextTick(() => {
        this.$refs.buyerInput.focus()
      })
    },
    formDisabled(key) {
      return this.form.tails.includes(key)
    },
    qryLab() {
      qryLab({ bu: this.bu, system: 'ticOrder', isShowCustomer: 1 }, this.host.javaUrl).then(res => {
        if (res.resultCode === '0') {
          this.labList = res.data.items
          let lab = getParam(this.$route.query, 'lab')
          lab = decodeURIComponent(lab)
          this.hasLab = this.labList.some(v => {
            if (v.labCode.replace(/\s/g, '').toLowerCase() === lab.replace(/\s/g, '').toLowerCase()) {
              this.form.labId = v.labId
              this.form.tails.push('lab')
              return true
            }
          })
        } else {
          this.$message.error(res.resultMsg)
        }
      }).catch(e => {
      })
    },
    flgChange(val, key) {
      if (val === 1) {
        this.form[key] = ''
      }
    },
    getValidate() {
      let data = JSON.parse(JSON.stringify(this.form))
      data.tails = this.form.tails.join(',')
      if (this.moduleData.getFormatJson) {
        data = this.formatByJson(data, this.moduleData.getFormatJson)
      }
      this.$emit('input', JSON.parse(JSON.stringify(data)))
      return new Promise(resolve => this.$refs.form.validate(resolve))
    },
  }
}
</script>

<style scoped>

</style>